<template>
<div class="chapter">
<div class="inner_page">
<p class="c4"><a class="calibre5" id="page_7"></a>Works by Herman Wouk</p>
<p class="c191a"><em class="calibre7">Aurora Dawn</em></p>
<p class="c191a"><em class="calibre7">City Boy</em></p>
<p class="c191a"><em class="calibre7">The Caine Mutiny</em></p>
<p class="c191a"><em class="calibre7">Marjorie Morningstar</em></p>
<p class="c191a"><em class="calibre7">Youngblood Hawke</em></p>
<p class="c191a"><em class="calibre7">Don't Stop the Carnival</em></p>
<p class="c191a"><em class="calibre7">The Winds of War</em></p>
<p class="c191a"><em class="calibre7">War and Remembrance</em></p>
<p class="c191a"><em class="calibre7">Inside, Outside</em></p>
<p class="c5"><em class="calibre7">This Is My God</em> (nonfiction)</p>
<p class="c191a"><em class="calibre7">The Caine Mutiny Court-Martial</em> (play)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?3316f6c7